import React from "react";
import { greeting, socialMediaLinks } from "../portfolio";
import { FaGithub, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { HiMail } from "react-icons/hi";

function Footer() {
  const currentYear = new Date().getFullYear();

  const socials = [
    { href: socialMediaLinks.github, icon: FaGithub, label: "GitHub" },
    { href: socialMediaLinks.linkedin, icon: FaLinkedinIn, label: "LinkedIn" },
    { href: `mailto:${socialMediaLinks.gmail}`, icon: HiMail, label: "Email" },
    { href: socialMediaLinks.instagram, icon: FaInstagram, label: "Instagram" },
  ];

  return (
    <footer className="border-t border-surface/[0.04]">
      <div className="container-main py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="text-center sm:text-left">
            <span className="font-display text-sm font-semibold text-fg-muted">
              {greeting.logo_name}
            </span>
          </div>

          <div className="flex items-center gap-4">
            {socials.map(({ href, icon: Icon, label }) => (
              <a
                key={label}
                href={href}
                target={label === "Email" ? undefined : "_blank"}
                rel="noopener noreferrer"
                aria-label={label}
                className="text-fg-ghost hover:text-fg-muted transition-colors duration-300"
              >
                <Icon size={14} />
              </a>
            ))}
          </div>
        </div>

        <div className="mt-6 pt-5 border-t border-surface/[0.03] text-center">
          <p className="text-[11px] text-fg-ghost font-mono">
            &copy; {currentYear} {greeting.full_name}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
